
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/examples/context",
      function () {
        return require("private-next-pages/examples/context.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/examples/context"])
      });
    }
  